import axios from 'axios';

class RegisterCancelTokenAxios {
  listSourceByReducerName = {};

  register(name) {
    const source = axios.CancelToken.source();
    this.add(source, name);
    return source;
  }

  add(source, name) {
    if (this.listSourceByReducerName[name]) {
      this.listSourceByReducerName[name].push(source);
    } else {
      this.listSourceByReducerName[name] = [source];
    }
  }

  delete(name) {
    if (this.listSourceByReducerName[name]) {
      this.listSourceByReducerName[name].forEach(source => {
        source.cancel();
      });
      delete this.listSourceByReducerName[name];
    }
  }

  deleteAll() {}
}

export default new RegisterCancelTokenAxios();
